<template>
  <div :class="device.desktop ? `usr pa-6` : `usr pa-2`">
    <div class="usr-panel">
      <!-- Header panel: judul, pencarian & aksi -->
      <div class="usr-panel-header">
        <v-icon
          small
          color="#60a5fa"
          class="mr-2"
        >mdi-account-group-outline</v-icon>
        <span class="usr-panel-title">DAFTAR PENGGUNA</span>
        <span class="usr-panel-count">{{ table.total || records.length }} pengguna</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="table.options.search"
          append-icon="mdi-magnify"
          label="Cari pengguna..."
          single-line
          hide-details
          solo
          flat
          dense
          dark
          background-color="#0a1224"
          color="#60a5fa"
          class="usr-search"
          style="max-width: 300px"
        ></v-text-field>
        <v-tooltip
          bottom
          color="#1e2c4f"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              dark
              v-on="on"
              v-show="page.actions.refresh"
              @click="fetchRecords"
              class="ml-2"
            >
              <v-icon color="#94a3b8">mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Refresh Data</span>
        </v-tooltip>
        <v-tooltip
          bottom
          color="#1e2c4f"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              dark
              v-on="on"
              v-show="page.actions.export"
              @click="addNewRecord"
            >
              <v-icon color="#94a3b8">mdi-file-export-outline</v-icon>
            </v-btn>
          </template>
          <span>Export Data</span>
        </v-tooltip>
        <v-btn
          depressed
          dark
          small
          class="usr-btn-primary ml-2"
          v-show="page.actions.add"
          @click="addNewRecord"
        >
          <v-icon
            left
            small
          >mdi-account-plus-outline</v-icon>
          Tambah
        </v-btn>
      </div>

      <!-- Tabel desktop -->
      <v-data-table
        v-show="device.desktop"
        :headers="headers"
        :items="records"
        :options.sync="table.options"
        :server-items-length="table.total"
        class="usr-table"
        dark
        :loading="loading.table"
        :search="table.options.search"
        loading-text="Memuat data pengguna..."
        show-select
      >
        <v-progress-linear
          slot="progress"
          color="#3b82f6"
          height="2"
          indeterminate
        ></v-progress-linear>

        <template v-slot:item.name="{ value }">
          <div class="usr-name">
            <v-icon
              small
              color="#60a5fa"
              class="mr-2"
            >mdi-account-circle-outline</v-icon>
            {{ value }}
          </div>
        </template>

        <template v-slot:item.authent="{ value }">
          <span class="usr-level-chip">{{ value || "-" }}</span>
        </template>

        <template v-slot:item.status="{ value }">
          <span
            class="usr-status"
            :class="value ? `usr-status--on` : `usr-status--off`"
          >
            <span class="usr-status-dot"></span>
            {{ value ? "Aktif" : "Nonaktif" }}
          </span>
        </template>

        <template v-slot:item.id="{ value }">
          <v-menu
            bottom
            origin="center center"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="#60a5fa"
                v-bind="attrs"
                v-on="on"
              >
                mdi-dots-vertical-circle-outline
              </v-icon>
            </template>

            <v-list
              dark
              color="#101b36"
            >
              <v-list-item @click="editRecord(value)">
                <v-list-item-title>
                  <v-icon color="orange">mdi-pencil-circle</v-icon>
                  Ubah Data
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openPwdForm(value)">
                <v-list-item-title>
                  <v-icon color="#60a5fa">mdi-key-variant</v-icon>
                  Ganti Kata Sandi
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="postDeleteRecord(value)">
                <v-list-item-title>
                  <v-icon color="red">mdi-delete-circle</v-icon>
                  Hapus
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>

      <!-- Daftar mobile -->
      <v-list
        subheader
        three-line
        v-show="device.mobile"
        dark
        color="#101b36"
      >
        <v-list-item-group
          multiple
          active-class=""
        >
          <v-list-item
            v-for="item in filterItems"
            :key="item.id"
          >
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox
                  :input-value="active"
                  color="#60a5fa"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> {{ item.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.email }} </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-menu
                  bottom
                  origin="center center"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="#60a5fa"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-dots-vertical-circle-outline
                    </v-icon>
                  </template>

                  <v-list
                    dark
                    color="#101b36"
                  >
                    <v-divider v-if="page.delete || page.edit"></v-divider>
                    <v-list-item
                      @click="editRecord(item.id)"
                      v-show="page.actions.edit"
                    >
                      <v-list-item-title>
                        <v-icon color="orange">mdi-pencil-circle</v-icon>
                        Ubah Data
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openPwdForm(item.id)">
                      <v-list-item-title>
                        <v-icon color="#60a5fa">mdi-key-variant</v-icon>
                        Ganti Kata Sandi
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="postDeleteRecord(item.id)"
                      v-show="page.actions.delete"
                    >
                      <v-list-item-title>
                        <v-icon color="red">mdi-delete-circle</v-icon>
                        Hapus Data
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>

    <!-- Dialog form tambah/ubah -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="page.add"
      :max-width="device.desktop ? `640px` : `100%`"
      persistent
      :fullscreen="device.mobile"
    >
      <v-card
        color="#101b36"
        dark
        class="usr-dialog"
      >
        <div class="usr-dialog-header">
          <v-icon
            small
            color="#60a5fa"
            class="mr-2"
          >{{ page.edit ? `mdi-account-edit-outline` : `mdi-account-plus-outline` }}</v-icon>
          <span class="usr-panel-title">{{ page.edit ? `UBAH DATA PENGGUNA` : `TAMBAH DATA PENGGUNA` }}</span>
        </div>
        <v-card-text class="usr-dialog-body">
          <!-- Informasi pengguna -->
          <div class="usr-section-title">
            <v-icon
              small
              color="#93c5fd"
            >mdi-account-outline</v-icon>
            Informasi Pengguna
          </div>
          <v-row dense>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-text-field
                label="Nama Pengguna"
                dark
                color="#60a5fa"
                background-color="#0a1224"
                autocomplete="off"
                outlined
                dense
                persistent-hint
                hint="Nama lengkap pengguna"
                v-model="record.name"
                prepend-inner-icon="mdi-account-outline"
              >
              </v-text-field>
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-text-field
                label="Email"
                dark
                color="#60a5fa"
                background-color="#0a1224"
                type="email"
                autocomplete="off"
                persistent-hint
                hint="Email aktif untuk login aplikasi"
                v-model="record.email"
                outlined
                dense
                prepend-inner-icon="mdi-email-outline"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Hak akses -->
          <div class="usr-section-title">
            <v-icon
              small
              color="#93c5fd"
            >mdi-shield-account-outline</v-icon>
            Hak Akses
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-select
                label="Level"
                dark
                color="#60a5fa"
                background-color="#0a1224"
                v-model="record.authent"
                :items="authents"
                persistent-hint
                hint="Level menentukan menu yang dapat diakses"
                outlined
                dense
                prepend-inner-icon="mdi-shield-key-outline"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              v-if="record.authent === 'operator'"
            >
              <v-autocomplete
                label="CCTV yang dapat diakses"
                dark
                color="#60a5fa"
                background-color="#0a1224"
                v-model="record.cctv_uuids"
                :items="cctvOptions"
                item-text="text"
                item-value="value"
                multiple
                chips
                small-chips
                deletable-chips
                clearable
                outlined
                dense
                persistent-hint
                hint="Pilih kamera yang boleh dipantau oleh operator ini"
                prepend-inner-icon="mdi-cctv"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <!-- Status akun -->
          <div class="usr-section-title">
            <v-icon
              small
              color="#93c5fd"
            >mdi-account-cog-outline</v-icon>
            Status Akun
          </div>
          <div class="usr-switches">
            <div class="usr-switch-box">
              <v-switch
                label="Status Aktif"
                color="#3b82f6"
                dark
                v-model="record.status"
                hide-details
                class="mt-0"
              ></v-switch>
              <div class="usr-switch-note">Nonaktifkan untuk memblokir akses login</div>
            </div>
            <div class="usr-switch-box">
              <v-switch
                label="Reset Kata Sandi"
                color="#3b82f6"
                dark
                v-model="record.reset"
                hide-details
                class="mt-0"
              ></v-switch>
              <div class="usr-switch-note">Kata sandi kembali ke bawaan: <b>12345678</b></div>
            </div>
          </div>
        </v-card-text>
        <v-divider class="usr-dialog-divider"></v-divider>
        <v-card-actions class="justify-end pa-4">
          <v-btn
            text
            color="#94a3b8"
            @click="closeForm"
          >Batal</v-btn>
          <v-btn
            depressed
            dark
            class="usr-btn-primary"
            v-show="!page.edit"
            @click="postAddNewRecord"
          >
            <v-icon
              left
              small
            >mdi-content-save-outline</v-icon>
            Kirim
          </v-btn>
          <v-btn
            depressed
            dark
            class="usr-btn-primary"
            v-show="page.edit"
            @click="postUpdateRecord"
          >
            <v-icon
              left
              small
            >mdi-content-save-outline</v-icon>
            Kirim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog ganti kata sandi -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="pwd.dialog"
      :max-width="device.desktop ? `440px` : `100%`"
      persistent
      :fullscreen="device.mobile"
    >
      <v-card
        color="#101b36"
        dark
        class="usr-dialog"
      >
        <div class="usr-dialog-header">
          <v-icon
            small
            color="#60a5fa"
            class="mr-2"
          >mdi-key-variant</v-icon>
          <span class="usr-panel-title">GANTI KATA SANDI</span>
        </div>
        <v-card-text class="usr-dialog-body">
          <div class="usr-pwd-target">
            <v-icon
              small
              color="#60a5fa"
            >mdi-account-circle-outline</v-icon>
            <div>
              <div class="usr-pwd-target-name">{{ pwd.name || "-" }}</div>
              <div class="usr-pwd-target-email">{{ pwd.email || "-" }}</div>
            </div>
          </div>

          <v-text-field
            label="Kata Sandi Baru"
            dark
            color="#60a5fa"
            background-color="#0a1224"
            autocomplete="new-password"
            outlined
            dense
            persistent-hint
            hint="Minimal 8 karakter"
            v-model="pwd.password"
            :type="pwd.show ? `text` : `password`"
            :append-icon="pwd.show ? `mdi-eye-off-outline` : `mdi-eye-outline`"
            @click:append="pwd.show = !pwd.show"
            prepend-inner-icon="mdi-lock-outline"
            class="mt-4"
          ></v-text-field>

          <v-text-field
            label="Ulangi Kata Sandi"
            dark
            color="#60a5fa"
            background-color="#0a1224"
            autocomplete="new-password"
            outlined
            dense
            persistent-hint
            :hint="pwd.confirm && pwd.confirm !== pwd.password ? `Kata sandi tidak sama` : `Ketik ulang kata sandi baru`"
            v-model="pwd.confirm"
            :type="pwd.show ? `text` : `password`"
            :error="pwd.confirm !== `` && pwd.confirm !== pwd.password"
            prepend-inner-icon="mdi-lock-check-outline"
            class="mt-4"
            v-on:keyup.enter="postChangePwd"
          ></v-text-field>
        </v-card-text>
        <v-divider class="usr-dialog-divider"></v-divider>
        <v-card-actions class="justify-end pa-4">
          <v-btn
            text
            color="#94a3b8"
            @click="closePwdForm"
          >Batal</v-btn>
          <v-btn
            depressed
            dark
            class="usr-btn-primary"
            :disabled="!pwd.password || pwd.password.length < 8 || pwd.password !== pwd.confirm"
            :loading="pwd.loading"
            @click="postChangePwd"
          >
            <v-icon
              left
              small
            >mdi-content-save-outline</v-icon>
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "manajemen-user",
  data: () => ({
    num: 1,
    headers: [
      {
        text: "NAMA",
        align: "start",
        sortable: true,
        value: "name",
      },
      { text: "EMAIL", value: "email" },
      {
        text: "LEVEL",
        value: "authent",
        align: "center",
        sortable: false,
        width: 140,
      },
      {
        text: "STATUS",
        value: "status",
        align: "center",
        sortable: false,
        width: 120,
      },
      {
        text: "AKSI",
        value: "id",
        align: "center",
        sortable: false,
        width: 50,
      },
    ],
    status: [
      { text: "Aktif", value: 0 },
      { text: "Non Aktif", value: 1 },
    ],
    authents: [
      { text: "Superadmin", value: "superadmin" },
      { text: "Administrator", value: "administrator" },
      { text: "Operator", value: "operator" },
    ],
    cctvOptions: [],
    search: null,

    pwd: {
      dialog: false,
      id: null,
      name: null,
      email: null,
      password: "",
      confirm: "",
      show: false,
      loading: false,
    },
  }),
  computed: {
    ...mapState([
      "page",
      "theme",
      "http",
      "device",
      "record",
      "records",
      "loading",
      "event",
      "table",
      "snackbar",
    ]),

    filterItems() {
      if (this.search != null) {
        return this.records.filter((item) => {
          return (
            item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        });
      } else {
        return this.records;
      }
    },
  },
  watch: {
    "record.authent"(val) {
      if (val === "operator" && !Array.isArray(this.record.cctv_uuids)) {
        this.setRecord({ ...this.record, cctv_uuids: [] });
      }
    },
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/utility/users",
      pagination: true,
      title: "MANAJEMEN PENGGUNA",
      subtitle: "Berikut Daftar Pengguna Yang Tersedia",
      breadcrumbs: [
        {
          text: "Utility",
          disabled: true,
          href: "",
        },
        {
          text: "Pengguna",
          disabled: false,
          href: "master-jenis-pengaduan",
        },
      ],
      add: false,
      edit: false,
      actions: {
        refresh: true,
        add: true,
        edit: true,
        delete: true,
      },
    });
    this.fetchCctvOptions();
  },
  methods: {
    ...mapActions([
      "setPage",
      "fetchRecords",
      "postAddNew",
      "postEdit",
      "postUpdate",
      "postConfirmDelete",
      "setRecord",
    ]),

    fetchCctvOptions: async function () {
      try {
        const { data } = await this.http.get("api/superadmin/master-data/cctv");
        const rows = Array.isArray(data) ? data : [];
        this.cctvOptions = rows.map((item) => ({
          text: `${item.area || "-"} — ${item.name || "-"}${
            item.identity ? ` (${item.identity})` : ""
          }`,
          value: item.id,
        }));
      } catch (e) {
        this.cctvOptions = [];
      }
    },

    addNewRecord: function () {
      this.setRecord({
        name: "",
        email: "",
        authent: "operator",
        status: true,
        reset: false,
        cctv_uuids: [],
      });
      this.setPage({
        add: true,
        edit: false,
      });
    },

    closeForm: function () {
      this.setPage({
        add: false,
        edit: false,
      });
    },

    postAddNewRecord: function () {
      const payload = {
        ...this.record,
        cctv_uuids:
          this.record.authent === "operator"
            ? this.record.cctv_uuids || []
            : [],
      };
      this.postAddNew(payload).then((ok) => {
        if (ok) {
          this.fetchRecords();
          this.closeForm();
        }
      });
    },
    editRecord: function (val) {
      this.postEdit(val);
      this.setPage({
        add: true,
        edit: true,
      });
    },

    postUpdateRecord: function () {
      const payload = {
        ...this.record,
        cctv_uuids:
          this.record.authent === "operator"
            ? this.record.cctv_uuids || []
            : [],
      };
      this.postUpdate(payload).then((ok) => {
        if (ok !== false) {
          this.fetchRecords();
          this.closeForm();
        }
      });
    },

    postDeleteRecord: function (val) {
      this.postConfirmDelete(val);
    },

    openPwdForm: async function (id) {
      this.pwd.id = id;
      this.pwd.password = "";
      this.pwd.confirm = "";
      this.pwd.show = false;
      this.pwd.dialog = true;

      const row = this.records.find((item) => item.id === id);
      if (row) {
        this.pwd.name = row.name;
        this.pwd.email = row.email;
      } else {
        this.pwd.name = null;
        this.pwd.email = null;
      }
    },

    closePwdForm: function () {
      this.pwd.dialog = false;
    },

    postChangePwd: async function () {
      if (!this.pwd.password || this.pwd.password.length < 8) return;
      if (this.pwd.password !== this.pwd.confirm) return;

      this.pwd.loading = true;
      try {
        let {
          data: { status, message },
        } = await this.http.post("api/utility/change-user-pwd", {
          id: this.pwd.id,
          password: this.pwd.password,
        });

        this.snackbar.color = status ? "green" : "red";
        this.snackbar.text = message;
        this.snackbar.state = true;

        if (status) {
          this.closePwdForm();
        }
      } catch (error) {
        this.snackbar.color = "red";
        this.snackbar.text = "Opps..., terjadi kesalahan " + error;
        this.snackbar.state = true;
      }
      this.pwd.loading = false;
    },
  },
  watch: {
    "table.options": {
      handler() {
        this.page.edit ? "" : this.fetchRecords();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.usr {
  min-height: 100%;
  background: #0a1224;
}

.usr-panel {
  background: #101b36;
  border: 1px solid #1e2c4f;
  border-radius: 12px;
  overflow: hidden;
}

.usr-panel-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #1e2c4f;
}

.usr-panel-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #e2e8f0;
}

.usr-panel-count {
  margin-left: 10px;
  padding: 2px 10px;
  border-radius: 999px;
  background: #0a1224;
  border: 1px solid #1e2c4f;
  font-size: 10px;
  font-weight: 600;
  color: #93c5fd;
}

.usr-search >>> .v-input__slot {
  border: 1px solid #1e2c4f;
  border-radius: 8px;
}

.usr-btn-primary {
  border-radius: 8px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #1d4ed8 0%, #0b3a79 100%) !important;
}

/* tabel gelap */
.usr-table {
  background: #101b36 !important;
}

.usr-table >>> thead th {
  background: #0d1730 !important;
  color: #93c5fd !important;
  font-size: 11px !important;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #1e2c4f !important;
}

.usr-table >>> tbody td {
  color: #cbd5e1 !important;
  font-size: 13px !important;
  border-bottom: 1px solid #16224384 !important;
}

.usr-table >>> tbody tr:hover {
  background: #16224384 !important;
}

.usr-table >>> .v-data-footer {
  background: #0d1730;
  border-top: 1px solid #1e2c4f !important;
  color: #94a3b8;
}

.usr-name {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #e2e8f0;
}

.usr-level-chip {
  display: inline-block;
  padding: 2px 12px;
  border-radius: 999px;
  background: #0a1224;
  border: 1px solid #1e2c4f;
  font-size: 11px;
  font-weight: 600;
  color: #93c5fd;
  text-transform: capitalize;
}

.usr-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
}

.usr-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
}

.usr-status--on {
  color: #22c55e;
}

.usr-status--off {
  color: #ef4444;
}

.usr-pwd-target {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
  padding: 10px 14px;
  border-radius: 10px;
  background: #0a1224;
  border: 1px solid #1e2c4f;
}

.usr-pwd-target-name {
  font-size: 13px;
  font-weight: 700;
  color: #e2e8f0;
}

.usr-pwd-target-email {
  font-size: 11px;
  color: #94a3b8;
}

/* dialog */
.usr-dialog {
  border: 1px solid #1e2c4f;
}

.usr-dialog-header {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #1e2c4f;
  background: #0d1730;
}

.usr-dialog-body {
  padding-top: 4px;
}

.usr-dialog-divider {
  border-color: #1e2c4f !important;
}

.usr-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #93c5fd;
  margin: 18px 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px dashed #1e2c4f;
}

.usr-switches {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.usr-switch-box {
  flex: 1;
  min-width: 220px;
  padding: 12px 16px;
  border-radius: 10px;
  background: #0a1224;
  border: 1px solid #1e2c4f;
}

.usr-switch-note {
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
}
</style>
